module.exports = __webpack_public_path__ + "media/components/lesson3/statics/receiveMessage-709b062aa1cdae95558cafacaff5d340.png";